<template>
  <table class="ui-table mb-16">
    <tr>
      <th>
        <div class="star-pad">
          <UiStar></UiStar>
        </div>
      </th>
      <th>
        <div>
          <SortIcon name="firstName" :ds="ds">{{
            $t('Rejected.applicant')
          }}</SortIcon>
        </div>
      </th>
      <th>
        <div>{{ $t('Rejected.shift_date') }}</div>
      </th>
      <th title="Is registered nurse">
        <div>{{ $t('Rejected.rn') }}</div>
      </th>
      <th>
        <div>{{ $t('Rejected.profession') }}</div>
      </th>
      <th>
        <div>{{ $t('Rejected.confidence') }}</div>
      </th>
      <th>
        <div>{{ $t('Rejected.status') }}</div>
      </th>
      <th>
        <div>{{ $t('Rejected.cv') }}</div>
      </th>
    </tr>

    <tr
      v-for="item in items"
      :key="item.id"
      @click="$emit('select', item)"
      class="hoverable"
      :class="{ hover: item.id === currentItemId }"
    >
      <td>
        <div class="table-cell star-pad">
          <UiStar :user="item"></UiStar>
        </div>
      </td>

      <td>
        <div class="table-cell nowrap">
          <UiAvatar
            class="user-avatar"
            :src="getAvatarUrl(item?.user?.photo?.key)"
          ></UiAvatar>
          <span>
            {{ item.user.firstName }}&nbsp;{{ item.user.middleName }}&nbsp;{{
              item.user.lastName
            }}
            <div class="mini-date">
              {{ $dayjs(item.createdAt).format('DD/MM/YYYY') }}
            </div>
          </span>
        </div>
      </td>
      <td>
        <div class="nowrap">
          {{ $dayjs(item.createdAt).format('DD/MM/YYYY') }}
        </div>
      </td>
      <td>
        <div>{{ item.detail.hasAllowedProfession ? 'Yes' : 'No' }}</div>
      </td>
      <td>
        <div>{{ item.detail?.currentProfession }}</div>
      </td>
      <td>
        <div>{{ item.detail?.motivation?.howSerious }}%</div>
      </td>
      <td>
        <div class="nowrap">{{ item?.lastStatusTitle }}</div>
      </td>
      <td>
        <div class="cv" v-if="item?.cv?.key" @click.stop="downloadCV(item)"></div>
        <div v-else>n/a</div>
      </td>
    </tr>
  </table>
</template>

<script>
import config from '@/config'
import UiAvatar from '@/components/ui/UiAvatar'
import UiStar from '@/components/ui/UiStar'
import SortIcon from '@/components/SortIcon'

export default {
  name: 'Rejected',
  components: { SortIcon, UiStar, UiAvatar },
  props: {
    items: {
      type: Array,
      required: true,
    },
    currentItemId: {},
    ds: {
      type: Object,
      required: true,
    },
  },
  emits: ['select'],
  methods: {
    getAvatarUrl(key) {
      if (key)
        return `${config.backendUrl}/${key}?token=${localStorage['feathers-jwt']}`
      else return require('@/assets/images/no-avatar.jpg')
    },
    downloadCV(student) {
      const url = `${config.backendUrl}/${student.cv.key}?token=${localStorage['feathers-jwt']}`
      this.$log(url)
      window.open(url)
    },
  },
}
</script>

<style scoped></style>
